// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".small-dognut{max-height:120px;max-width:120px}.info_icon{font-size:.8rem !important}.tooltip_text{max-width:16rem !important;display:inline-block;font-size:larger}.event-detail-user-list-row{padding:0px 10px !important;min-height:60px;margin:10px auto}.event-detail-user-list-row:hover{cursor:pointer}.event-detail-user-list-row .list-item{border-bottom:1px solid #fff;display:table;width:100%;max-height:60px;height:60px;padding:5px}.event-detail-user-list-row .list-item span{display:table-cell;vertical-align:middle}.event-detail-user-list-row .list-item span .user-icon{height:40px}.event-detail-user-list-row .legend_unit__m::after{content:\" m\";position:relative;top:-2px}.event-detail-user-list-row .legend_unit__min::after{content:\" min\";position:relative;top:-2px}", ""]);
// Exports
exports.locals = {
	"bg-green-gradient": "linear-gradient(rgb(47, 174, 67), rgb(43, 128, 59))",
	"bg-gray-gradient": "linear-gradient(rgb(72, 85, 98), rgb(43, 52, 61))",
	"dark-gray": "#2b343d",
	"black": "#000",
	"white": "#fff",
	"transparent-white": "rgba(255,255,255,.2)",
	"gray": "#b6b6b6",
	"light-gray": "#333d46",
	"bright-green": "#4abe5d",
	"brightest-green": "#28f747",
	"green": "#2c9141",
	"peach": "#ea5e5b",
	"yellow": "#cda800",
	"orange": "#f59b1a",
	"on-orange": "#2e865f",
	"bright-blue": "#157efb",
	"border-header-footer": "20px",
	"purple": "#7a4ef6",
	"bg-orange": "#ff6c29",
	"dialog-border-radius": "20px"
};
module.exports = exports;
